import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query';
import { AdminService } from '../admin.service';

export const useGetMeAdmin = (
	options?: Omit<
		UseQueryOptions<Admins.Admin, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['admin-me'],
		queryFn: () => AdminService.getMeAdmin(),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetAdmins = (
	options?: Omit<
		UseQueryOptions<Admins.Admin[], Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['admins'],
		queryFn: () => AdminService.getAll(),
		refetchOnWindowFocus: false,
		...options,
	});
};
